import React from 'react';
import classNames from 'classnames';
import BackIcon from '../../assets/logo/BackIcon';
import InfoIcon from '../../assets/logo/InfoIcon';
import Theme from '../../components-library/Theme';
import { useTranslation } from 'react-i18next';

type AllergensButtonProps = {
  isOpen: boolean;
  toggleAllergens: () => void;
  className?: string;
};

const AllergensButton = (props: AllergensButtonProps) => {
  const { isOpen, toggleAllergens, className } = props;
  const { t } = useTranslation(null, { keyPrefix: 'Shared:Allergens' });

  return (
    <button className={classNames('flex space-x-2 items-center', className)} onClick={toggleAllergens}>
      <span
        className={classNames({
          'rounded-full flex items-center justify-center': isOpen,
        })}
      >
        {isOpen ? (
          <div className="w-[18px] h-[18px] flex items-center justify-center border-[1px] border-mobile-secondary rounded-full">
            <BackIcon className="w-[7px] h-[10px] mr-[2px]" color={Theme.color.gray[700]} />
          </div>
        ) : (
          <InfoIcon className="w-[18px] h-[18px]" color={Theme.color.gray[700]} fill={false} />
        )}
      </span>
      <p className="text-sm text-brand-text-secondary">{isOpen ? t('buttons.return') : t('buttons.product_info')}</p>
    </button>
  );
};

export default AllergensButton;
